import axios from "axios";

    const ENDPOINT = process.env.REACT_APP_ENDPOINT
    
export const apiConstants = {
    BASE_LOCAL: ENDPOINT,
    GENERATE_OTP: 'returnAndExchangeOrder/generateOtpForReturnAndExchangeOrder',
    VERIFY_OTP: 'returnAndExchangeOrder/verifyOtpForReturnAndExchangeOrder',
    RETURN_DATA: 'returnAndExchangeOrder/saveOrderForReturnAndExchange',
    SEND_RETURN_PLACED_MESSAGE: 'returnAndExchangeOrder/sendReturnsPlacedMessage',
    CONFIG_DATA: 'merchantDesc/config/getByOid',
    GET_CONFIG_DATA: 'merchantDesc/config/getMerchantDescConfigByAwb',
    GET_CONFIG_DATA_BY_BRAND: 'merchantDesc/config/getMerchantDescConfigByBrandUrl',
};


export function postMultipart(endpoint, data) {
    return axios.post(`${ENDPOINT}${endpoint}`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}

export function postGeneric(endpoint, data) {
    let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
    return axios.post(`${finalUrl}`, data)
}

export function getGeneric(endpoint, params = {}) {
    const searchParams = new URLSearchParams(params);
    for (const k of Object.keys(params)) {
        searchParams.set(k, params[k])
    }

    let finalUrl = `${apiConstants.BASE_LOCAL}${endpoint}`
    if (Object.keys(params).length > 0) {
        finalUrl += `?${searchParams.toString()}`;
    }

    return axios.get(finalUrl)
}
